import { useEffect, useRef } from 'react';

const useLastClickedElement = () => {
  const lastClickedElementRef = useRef(null);

  useEffect(() => {
    const handleGlobalClick = (event) => {
      lastClickedElementRef.current = event.target.parentElement;
    };

    document.addEventListener('mousedown', handleGlobalClick);
    return () => document.removeEventListener('mousedown', handleGlobalClick);
  }, []);

  return lastClickedElementRef;
}

export default useLastClickedElement;
